import moment from 'moment';
export var SIGN_SELECT_STATUS;
(function (SIGN_SELECT_STATUS) {
    SIGN_SELECT_STATUS[SIGN_SELECT_STATUS["NO_SIGNATURE"] = -1] = "NO_SIGNATURE";
    SIGN_SELECT_STATUS[SIGN_SELECT_STATUS["UNINITIALIZED"] = -2] = "UNINITIALIZED";
})(SIGN_SELECT_STATUS || (SIGN_SELECT_STATUS = {}));
const initState = {
    scheduleSync: null,
    scheduleEvent: null,
    catalogList: [],
    unSelectedCatalogIds: [],
    miniSelectedDay: moment(),
    scheduledDate: [],
    showWebWriteLetter: true,
    selector: {
        focused: '',
        add: false,
        pendingItem: null,
    },
    mails: [],
    attachments: [],
    currentMail: {},
    unreadCount: {},
    attachmentsPreview: {
        visible: false,
        attType: undefined,
        downloadContentId: null,
        downloadId: null,
    },
    contact: {},
    editorTooltip: {
        top: -999,
        left: 0,
        title: '',
    },
    mailTagList: [],
    scheduleEventList: [],
    weekFirstDay: 0,
    weekNumbersVisible: false,
    activeStartDate: new Date(),
    activeEndDate: new Date(),
    scheduleNoticeLastUpdateTime: new Date(Date.now() - 60 * 60 * 1000),
    showSecondaryZone: false,
    settingZoneList: [],
    scheduleEditFrom: '',
    lastSelectTimezone: null,
};
export default initState;
